import { External } from '../../external';

const BASE_URL = `https://${External.serviceApiDomain}/comment/admin`;
const WallsService = {
  getContexts: async () => {
    const url = `${BASE_URL}/context?resourceType=wall`;
    const response = await fetch(url, {
      method: 'GET',
      cache: 'no-cache',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'X-Website-Hash': External.WebPlatform.hash,
        'X-Admin-Hash': External.Website.hash
      }
    });

    return await response.json();
  },
  createContext: async (name) => {
    const url = `${BASE_URL}/context`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Website-Hash': External.WebPlatform.hash,
        'X-Admin-Hash': External.Website.hash
      },
      body: JSON.stringify({
        name: name,
        resourceType: 'wall',
        resourceId: new Date().getTime(),
        moderation: { writePermission: 2, approvalRequired: 2 },
        commentModeration: { writePermission: 2, approvalRequired: 2 },
        extra: {
          allowMentions: true,
          allowImages: true,
        }
      })
    });

    return await response.json();
  },
  partialUpdateContext: async (resourceType, resourceId, partialUpdate) => {
    const url = `${BASE_URL}/context`;
    const response = await fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-Website-Hash': External.WebPlatform.hash,
        'X-Admin-Hash': External.Website.hash
      },
      body: JSON.stringify({
        resourceType: resourceType,
        resourceId: resourceId,
        ...partialUpdate
      })
    });

    return await response.json();
  }
};

export default WallsService;
